function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 6.75,
  r: 3.75,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99996 0C5.278 0 2.25 3.00509 2.25 6.69886C2.25 8.765 3.32188 11.2728 5.43595 14.1526C6.98304 16.2602 8.50755 17.7632 8.5717 17.8262C8.68962 17.942 8.84476 18 9.00007 18C9.15088 18 9.30179 17.9452 9.41878 17.8354C9.48307 17.775 11.0114 16.3328 12.5615 14.2543C14.6772 11.4172 15.75 8.87518 15.75 6.69883C15.7499 3.00509 12.7219 0 8.99996 0ZM8.99996 9.59086C7.18033 9.59086 5.69999 8.14762 5.69999 6.37367C5.69999 4.59971 7.18036 3.15648 8.99996 3.15648C10.8196 3.15648 12.2999 4.59971 12.2999 6.37367C12.2999 8.14762 10.8195 9.59086 8.99996 9.59086Z",
  fill: "#373737"
});

function SvgLocations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.efb09ba0.svg";
export { ForwardRef as ReactComponent };